<div class="app__discovery--widget--container">
  @if (showFirstStep) {
    <div>
      <div class="app__sub-title flex flex-col items-start text-[#53565B] font-semibold mt-5 m-0">
        <p>
          Do you want to add a <span class="font-weight-bold-blue"> new vault </span> for
          <span [matTooltip]="data?.form_name.length > 26 ? data.form_name : ''">{{ data?.form_name | truncateStrPipe : 26 }} </span> ?
        </p>
      </div>
      <p class="app__form--attribute--title text-sm font-normal leading-6">
        Creating a vault for each entity makes it easier to keep everything organized in the right place.
      </p>
      <div class="flex flex-col gap-3 w-[291px] mt-10">
        @for (option of options; track option) {
          <div
            [class]="option?.isSelected ? 'app__discovery-option-form-selected ' : 'app__discovery-option-form'"
            (click)="handleSteps(option.value)"
            >
            <span class="text-[20px] m-0 font-open-sans text-[#53565B] font-semibold leading-[22.5px]">
              {{ option.value }}
            </span>
          </div>
        }
      </div>
    </div>
  }

  @if (showSecondStep && !fromVault && !fromTemplateRegister) {
    <div
      class="app__itemCard-radioGroup app__sub-title items-start text-[#53565B] font-semibold mt-5 m-0"
      >
      @if (isLocationTitle) {
        <p>
          Select a <span class="font-weight-bold-blue"> Vault </span> for <span class="font-weight-bold-blue"> {{ form_name }} </span>
        </p>
      }
      @if (!isLocationTitle) {
        <p>
          Which <span class="font-weight-bold-blue"> Vault </span> do you want to put
          <span [matTooltip]="data?.form_name.length > 26 ? data.form_name : ''">{{ data?.form_name | truncateStrPipe : 26 }} </span> in?
        </p>
      }
    </div>
  }

  <!-- <div class="app__itemCard-radioGroup app__sub-title items-start text-[#53565B] font-semibold mt-5 m-0" *ngIf="showSecondStep || fromVault">
  <p>
    Add <span class="font-weight-bold-blue">Basic Information </span> for this
    <span *ngIf="vaultType">{{ vaultType }}</span>
    vault
  </p>
</div> -->

@if (showSecondStep && !fromVault) {
  <div class="app__discovery--header--search--field mt-4">
    <div class="app__centered-item w-full h-full px-5">
      <span> <img src="../../../../../../assets/images/search-icon.svg" /> </span>
      <input class="h-full w-full ml-2 border-none outline-none" [(ngModel)]="searchVault" type="text" placeholder="Search Vault" />
    </div>
  </div>
}

@if (showSecondStep && !fromVault) {
  <div class="app__discovery--options--section w-[calc(100%+30px)] mt-7"style="height: calc(100vh - 330px) !important">
    <div class="w-[692px]">
      <vault-card-list #vaultCardList [isAllVaults]="true" isHideMatMenu="true" [isFromTemplateRegister]="true" [searchText]="searchVault" (setDiscoverySetupVault)="setDiscoverySetupVault($event)"></vault-card-list>
    </div>
    <!-- @if (sharedVaultItems$ | async; as sharedVaultItems) {
      <div>
        @if (sharedVaultItems.length) {
          <div class="flex flex-wrap gap-4">
            <div
              class="app__discovery--rectangular--options"
              style="border: 1px dashed #25508ecc !important"
              [ngClass]="{ 'sm:w-[220px] sm:h-[200px]': is_check_box_selection }"
              >
              <div class="hover:cursor-pointer" (click)="addNewVault()">
                <span><img src="../../../../../../assets/images/add-vault.svg" width="60px" height="60px" /></span>
                <p class="paragraph__medium text-[13px] sm:text-[13px] leading-[22px]">Add Vault</p>
              </div>
            </div>
            @for (vault of sharedVaultItems | filterWorkspace : searchVault; track vault; let i = $index) {
              <div
          [class]="
            vault?.id == selected_item?.id && vault?.name == selected_item?.name
              ? 'app__discovery--rectangular-selected--options relative'
              : 'app__discovery--rectangular--options relative'
          "
                [ngClass]="{ 'sm:w-[220px] sm:h-[200px]': is_check_box_selection }"
                >
                <span class="app__discovery--option--top--aligned--tag paragraph__medium text-[10px] sm:text-[10px] leading-[14px]">
                  {{ vault?.type ?? 'shared' | capitalizeFirstWord  }}
                </span>
                <div class="app__centered-item block text-center hover:cursor-pointer" (click)="setDiscoverySetupVault(vault)">
                  <span>
                    @if(vault?.id == selected_item?.id && vault?.name == selected_item?.name){
                      <img src="assets/images/discovery/selected.svg" width="60px" height="60px" />
                      }@else{
                      <img
                        [src]="vault?.type ? '../../../../../../assets/images/' + vault.type + '.svg' : '../../../../../../assets/images/shared.svg'"
                        width="60px"
                        height="60px"
                        />
                      }
                    </span>
                    <p class="paragraph__medium text-[13px] sm:text-[13px] leading-[22px]" [matTooltip]="vault?.name.length > 22 ? vault.name:''">
                      {{ vault?.name | truncateStrPipe : 20 }}
                    </p>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="flex flex-row flex-wrap gap-4">
              @for (item of loaderItems; track item) {
                <div>
                  <div class="flex w-[220px] h-[200px] sm:w-[200px] sm:h-[180px]" id="{{ item.id }}">
                    <div class="ph-item w-full h-full rounded m-0 p-0">
                      <div class="ph-col-12 m-0 p-0">
                        <div class="ph-row w-full h-full">
                          <div class="ph-col-12 w-full h-full"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      } -->
    </div>
  }

  <!-- <div class="w-full mt-5" *ngIf="showSecondStep || fromVault">
  <mat-accordion>
    <mat-expansion-panel
      class="bg-[#fff] shadow-none mb-5 h-auto rounded-xl border-solid border"
      [ngClass]="{ 'border-[#1AA140]': stepOneCompleted, 'border-[#53565B38]': !stepOneCompleted }"
      [expanded]="step === 0"
      (opened)="setStep(0)"
      >
      <mat-expansion-panel-header class="disable_ripple">
        <mat-panel-title>
          <mat-icon *ngIf="stepOneCompleted" class="text-green-500 mr-2">check_circle_outline</mat-icon>
          <span class="app__form--attribute--title text-[16px] text-left font-semibold leading-[42px] mb-0" (click)="$event.stopPropagation()">
            Vault Type
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="flex items-center justify-center flex-wrap gap-[15px]">
        <div
          class="app__discovery--rectangular--options w-[153px] h-[104px]"
            [ngClass]="{
              ' bg-[#EFFFF7] border-[#1AA140]': item.isSelected,
              ' hover:rounded-xl hover:bg-white hover:border-1 hover:border-solid hover:border-[rgb(73,112,167)] hover:cursor-pointer':
                !item.isSelected
            }"
          *ngFor="let item of vaultTypeOptions; let i = index"
          (click)="handleSelectedVaultType(item)"
          >
          <div class="app__centered-item block relative text-center hover:cursor-pointer">
            <span class="absolute top-0 left-0 w-full h-full" *ngIf="item.isSelected"
              ><img src="assets/images/discovery/selected.svg" class="w-[52px] h-[52px]"
            /></span>
            <span> <img [src]="'../../../../../../assets/images/' + item.value + '.svg'" width="48px" height="48px" /> </span>
            <p class="paragraph__medium text-[13px] sm:text-[13px] leading-[22px]">
              {{ item?.displaytext }}
            </p>
          </div>
        </div>
      </div>
      <mat-action-row class="app__centered-item justify-end h-[50px] bg-[#DCDCDC29]">
        <button
          mat-button
          class="app__btn--primary w-[102px] mt-0"
          [class]="vaultType ? 'app__btn--primary ' : 'app__btn--disabled '"
          (click)="nextStep()"
          >
          Save
        </button>
      </mat-action-row>
    </mat-expansion-panel>

    <mat-expansion-panel
      class="shadow-none mb-5 h-auto rounded-xl border-solid border"
      [ngClass]="{ 'border-[#1AA140]': stepTwoCompleted, 'border-[#53565B38]': !stepTwoCompleted }"
      [expanded]="step === 1"
      (opened)="setStep(1)"
      >
      <mat-expansion-panel-header class="disable_ripple">
        <mat-panel-title>
          <mat-icon *ngIf="stepTwoCompleted" class="text-green-500 mr-2">check_circle_outline</mat-icon>
          <p class="app__form--attribute--title text-[16px] text-left font-semibold leading-[22px] mb-0" (click)="$event.stopPropagation()">
            Vault Name
          </p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="my-[10px]">
        <mat-form-field appearance="fill" class="w-full automtic-form-desing-form-only form-design-ui">
          <mat-label class="automtic-form-desing-lable"> Vault name </mat-label>
          <input
            matInput
            type="text"
            maxlength="50"
            placeholder="Untitled Vault"
            [(ngModel)]="vaultName"
            (focus)="selectAllContent($event)"
            (keydown)="disableWhiteSpaceOnFirstCharacter($event)"
            (input)="handleInput($event)"
            />
          </mat-form-field>
        </div>
        <mat-action-row class="app__centered-item justify-end h-[50px] bg-[#DCDCDC29]">
          <button
            mat-button
            class="app__btn--primary w-[102px]"
            [class]="vaultName.length ? 'app__btn--primary ' : 'app__btn--disabled '"
            (click)="nextStep()"
            >
            Save
          </button>
        </mat-action-row>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="shadow-none mb-5 h-auto rounded-xl border-solid border"
        [ngClass]="{ 'border-[#1AA140]': stepThreeCompleted, 'border-[#53565B38]': !stepThreeCompleted }"
        [expanded]="step === 2"
        (opened)="setStep(2)"
        >
        <mat-expansion-panel-header class="disable_ripple">
          <mat-panel-title>
            <mat-icon *ngIf="stepThreeCompleted" class="text-green-500 mr-2">check_circle_outline</mat-icon>
            <p class="app__form--attribute--title text-[16px] text-left font-semibold leading-[22px] mb-0" (click)="$event.stopPropagation()">
              Managing Members
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="h-[250px]">
            <div class="app__between--justified--content flex-col sm:flex-row items-center">
              <p class="app__text-higlight flex items-center text-[#25508E] text-sm">
                {{ stateObject?.first_name }}'s Connections
                <span
                  class="ml-1"
                  matTooltip="Managing members will automatically be given managerial permissions to this vault from their own Kinnect account"
                  >
                  <img src="../../../../../../assets/images/info-icon.svg" width="16px" height="16px"
                  /></span>
                  <span class="ml-2"><app-connection-modal (connectionCreated)="connectionCreated($event)"></app-connection-modal></span>
                </p>
                <div class="w-[240px] flex flex-col relative">
                  <div class="app__discovery--box--search--field">
                    <ng-container>
                      <div class="app__centered-item w-full h-full justify-between bg-transparent overflow-y-hidden" aria-label="Search connections">
                        <span class="material-icons text-k-blue"> search </span>
                        <input class="w-[90%] border-none outline-none" [(ngModel)]="searchUser" type="text" placeholder="Search connections" />
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="app__discovery--options app__centered-item">
                <ng-container *ngFor="let user of allConnections | filterWorkspace : searchUser">
                  <span
                    class="app__discovery--options--item"
                    [ngClass]="{ 'border-[#1AA140] bg-[#EFFFF7]': user.isSelected, 'border-[#9DB5E3]': !user.isSelected }"
                    [matTooltip]="user?.name.length > 20 ? user.name : ''"
                    matTooltipPosition="above"
                    (click)="handleSelectedUser(user)"
                    >
                    <ngx-avatars
                      class="custom-nx-avatar mr-2"
                      size="24"
                      [src]="user?.user_profile_image_url"
                      [name]="user?.name | titlecase"
                      [round]="false"
                      initialsSize="2"
                      cornerRadius="100"
                    ></ngx-avatars>
                    {{ user?.name | truncateStrPipe : 20 }}
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
          <mat-action-row class="app__centered-item justify-end h-[50px] bg-[#DCDCDC29]">
            <button mat-button class="app__btn--primary w-[102px] mt-0" (click)="nextStep()">Save</button>
          </mat-action-row>
        </mat-expansion-panel>
      </mat-accordion>
    </div> -->
  </div>

  @if (!fromTemplateRegister) {
    <mat-divider class="mat-divider m-0 sm:mb-5 sm:mt-[36px]" aria-orientation="horizontal"></mat-divider>
  }
  @if (!fromTemplateRegister) {
    <div
      class="flex items-start w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4"
      [ngClass]="{ 'justify-between': showBackButton, ' justify-end': !showBackButton }"
      >
      @if (showBackButton) {
        <button class="app__centered-item bg-transparent font-bold text-xs hover:cursor-pointer" (click)="handleSteps('backward')">
          <span class="app__centered-item gap-2 text-[#18191C]"
            ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
            >
          </button>
        }
        <!-- <div class="w-[158px]" *ngIf="showSecondStep || fromVault">
        <button
      [class]="
        vaultName && vaultType && members.length
          ? 'app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0'
          : 'app__btn--disabled mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0'
      "
          type="submit"
          (click)="createVault()"
          >
          Continue
        </button>
      </div> -->
    </div>
  }
